<template>
  <div class="personal-loan-interest-rate">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('string.newPawnInterestRate') }}
        </h3>
      </div>
      <div class="box-body">
        <purchasing-interest-rate-form />
      </div>
    </div>
  </div>
</template>

<script>
import PurchasingInterestRateForm from './Form'

export default {
  name: 'Create',
  metaInfo () {
    return {
      title: this.$t('string.newPurchasingInterestRate'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: {
    PurchasingInterestRateForm
  }
}
</script>

<style scoped>

</style>
